import './inbox_content.js.coffee';# Added by Script 
import './social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.EmailContent extends Monitoring.Models.SocialContents.InboxContent

  type: ->
    'email'

  subType: ->
    'email'

  getAttachments: (type) ->
    base = []
    try
      filteredEmbedUrls = @getFilteredEmbedUrl()
      standarizedAttachments = @getValues().standarized_attachments
      attachments = standarizedAttachments[type]
      filteredEmbedAttachments = @filteredEmbedAttachments(attachments, filteredEmbedUrls)

      formattedAttachments = @formatAttachments(type, filteredEmbedAttachments)

      i = 0
      while i < formattedAttachments.length
        if formattedAttachments[i].name == undefined
          formattedAttachments[i].name = @uniqueId(8)
        ++i

      return base.concat(formattedAttachments)
    catch error
      console.log(error)
      return base

  getFilteredEmbedUrl: ->
    filteredEmbedAttachmentsAsText = @getValues().attachment
    filteredEmbedAttachments = JSON.parse(filteredEmbedAttachmentsAsText)
    filteredEmbedUrls = []
    for filteredEmbedAttachment in filteredEmbedAttachments.data
      filteredEmbedUrls.push(filteredEmbedAttachment["file_url"])
    return filteredEmbedUrls

  filteredEmbedAttachments: (attachments, filteredUrls) ->
    attachments.filter (attachment) -> filteredUrls.includes(attachment["url"])

  formatAttachments: (type, attachments) ->
    if attachments?
      formattedAttachments = _.map(attachments, @attachmentTypesFormat(@applicationsPreview())[type].format)
    else
      formattedAttachments
    return formattedAttachments

  applicationsPreview: () ->
    {
      'doc': 'icon-attachment-doc.svg',
      'xls': 'icon-attachment-xls.svg',
      'ppt': 'icon-attachment-ppt.svg',
      'pdf': 'icon-attachment-pdf.svg',
      'file': 'icon-attachment-file.svg',
    }

  attachmentTypesFormat: (applicationsPreviews) ->
    {
      'images': {
        'format': (image) -> {
          url: image.url
          preview_url: image.preview_url
          mime_type: image.mime_type
          name: image.name
        }
      },
      'videos': {
        'format': (video) -> {
          url: video.url
          preview_url: window.image_path('icon-attachment-video.svg')
          mime_type: video.mime_type
          name: video.name
          height: video.height
          width: video.width
        }
      },
      'audios': {
        'format': (audio) -> {
          url: audio.url
          preview_url: window.image_path('icon-attachment-audio-file.svg')
          mime_type: audio.mime_type
          name: audio.name
        }
      },
      'applications': {
        'format': (application) -> {
          url: application.url
          preview_url: window.image_path(applicationsPreviews[application.application_type])
          mime_type: application.mime_type
          name: application.name
        }
      },
      'texts': {
        'format': (text) -> {
          url: text.url
          preview_url: window.image_path('icon-attachment-file.svg')
          mime_type: text.mime_type
          name: text.name
        }
      },
      'files': {
        'format': (file) -> {
          url: file.url
          preview_url: window.image_path('icon-attachment-file.svg')
          mime_type: file.mime_type
          name: file.name
        }
      }
    }
